// extracted by mini-css-extract-plugin
export var actions = "_hd-d";
export var benefitCard = "_hd-a";
export var benefitIcon = "_hd-b";
export var benefitLabel = "_hd-c";
export var benefits = "_hd-9";
export var bodyText = "_hd-8";
export var closeButton = "_hd-2";
export var content = "_hd-3";
export var eyebrow = "_hd-4";
export var heading = "_hd-5";
export var image = "_hd-f";
export var imagePanel = "_hd-e";
export var modal = "_hd-0";
export var shell = "_hd-1";
export var title = "_hd-6";
export var titleOffer = "_hd-7";